var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"fgc__header-c"}},[_c('CardLayoutLogo'),_c('CardLayoutTitle',[_vm._v(" Esqueceu sua senha? ")]),_c('CardLayoutSubtitle',[_vm._v(" Informe seu e-mail para enviarmos as instruções para redefinir sua senha ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }